import axiosInstance from '@/shared/services/http.service';
import type { Organization } from '@/shared/api/types';

export const getOrganizations = async ({
  skip,
  limit,
}: {
  skip: number;
  limit: number;
}) => {
  const response = await axiosInstance.get<{
    organizations: Organization[];
    total: number;
  }>('/organization/all', {
    params: {
      skip,
      limit,
    },
  });
  return response.data;
};

export const getOrganization = async () => {
  const response = await axiosInstance.get<Organization>(
    '/organization/id',
  );
  return response.data;
};
